import { useContext } from 'react';
import { UIContext } from './UIContext';

const useUI = () => {
  return useContext(UIContext);
};

export default useUI;
